
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Alumni Events</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg std-scholarship">
    <div class="container">
          <div class="row justify-content-center mb-20">
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/alumni-22.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/alumni-22.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>Alumni Forum 2022-23</h6></div>
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/reunoin.jpg" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/reunoin.jpg" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>Alumni Reunion</h6></div>
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/alumni-1.jpg" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/alumni-1.jpg" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>Alumni Coffee Cup Meet</h6></div>
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/raisoni-forum.jpg" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/raisoni-forum.jpg" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>Raisoni Forum Alumni</h6></div>
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/state-of-mind.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/state-of-mind.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>Guest Lecture</h6></div>
                    </a>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/alumni-event10.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/alumni-event10.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>Workshop</h6></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/alumni-event8.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/alumni-event8.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>IT Forum</h6></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/alumni-event9.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/alumni-event9.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"><h6>IT Forum</h6></div>
                    </a>
                </div>
            </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alimni-cofee-meet-ab.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alimni-cofee-meet-ab.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>Alumni Coffee Cup Meet</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-covide-19.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-covide-19.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>covid-19-Pandemic or Plandemic</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-talk-show.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-talk-show.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>Talk Show and Grooming Session</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-rendezious.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-rendezious.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>Rendezvous with Alumni</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-event1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-event1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>Alumni Happy Hours</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-event2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-event2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>Insights of Sports</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-event3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-event3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>CNA Forum</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-event4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-event4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>IT Forum</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-event5.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-event5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>Coffee Cup Meet</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-event6.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-event6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>Coffee Cup Meet</h6></div>
                      </a>
                  </div>
              </div>
              <div class="col-lg-3 col-md-3 col-6">
                  <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="assets/images/latest-news/alumni-event7.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                          <img class="img-fluid" src="assets/images/latest-news/alumni-event7.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                          <div class="gallery-overlay"><h6>IT Forum</h6></div>
                      </a>
                  </div>
              </div>
          </div>
        <div class="row justify-content-center mb-20">
            <div class="col-lg-12">                
                <div class="inner-title"  >
                    <h4>Press Release of Alumni Forum</h4>
                   
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-8.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-8.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-alu-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-alu-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-alu-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-alu-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-alu-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-alu-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-1.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-1.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-2.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-2.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-3.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-3.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-4.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-4.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-5.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-5.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-6.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-6.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/latest-news/forum-press-7.webp" data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/latest-news/forum-press-7.webp" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>